// extracted by mini-css-extract-plugin
export default {"manage-substatuses-grid-popup-client-name":"manage-substatuses-grid_manage-substatuses-grid-popup-client-name__BXJfU"};